import type { Application } from "../types";
import type { GeoDirectoryStore } from "../data/geoDirectoryStore";
import { geoLocationPassesFilter } from "./geoDirectorySelectOptions";

export function applicationMatchesGeoFilter(
  a: Application,
  opts: { district: string; mandal: string; village: string },
  geo?: GeoDirectoryStore | null,
): boolean {
  return geoLocationPassesFilter(geo, a, opts);
}
